import { render, staticRenderFns } from "./StudentScheduleExamTimeInfo.vue?vue&type=template&id=56f95a8b&"
import script from "./StudentScheduleExamTimeInfo.vue?vue&type=script&lang=js&"
export * from "./StudentScheduleExamTimeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports